import React, { FC } from "react";
import MuiSliderComponent, { SliderComponentProps } from "@CubeComponents/Mui_Form/SliderComponent";
import { createUseStyles } from "react-jss";
import { defaultSliderComponentProps } from "../../constants/globalVariable";
import { getSliderParentWrapperStyle, getSliderStyle } from "../../constants/globalFunctions";

// React 18.3 still applies `defaultProps` on a function component at runtime (it only warns; React 19
// is where it stops working), but @types/react 19 no longer declares the slot on `FC`, so it is
// declared here and the assignment below is typed instead of asserted. `typeof
// defaultSliderComponentProps` and not `Partial<SliderComponentProps>`: globalVariable.tsx declares
// that object with the older syncfusion interface, whose `width` is `number | string`. Optional on
// purpose - a required `defaultProps` makes `ReactManagedAttributes` mark every defaulted prop
// optional at the call sites.
const SliderComponent: FC<SliderComponentProps> & { defaultProps?: typeof defaultSliderComponentProps } = (
  props: SliderComponentProps,
) => {
  const useStyles = createUseStyles({
    parentWrapper: getSliderParentWrapperStyle(),
    // KNOWN BUG: all six style props are optional on `SliderComponentProps` (Mui_Form/SliderComponent.tsx),
    // but `getSliderStyle` declares its six parameters `string`, so every read is asserted. `defaultProps`
    // below supplies the four gradient colours only for as long as React still applies defaultProps to a
    // function component; `color` and `handleShadowColor` are passed by NO call site (ModelComparison.tsx,
    // Schedule/Gantt/DateSlider.tsx, PortalUpdateSeats/index.tsx), so those two are `undefined` here today.
    // To fix: widen the six parameters of `getSliderStyle` (cubeComponent/constants/globalFunctions.tsx)
    // to `string | undefined` and guard the unconditional `handleGradientColor1`/`handleGradientColor2`
    // interpolation there — it renders the literal text "undefined" into the gradient when they are absent.
    slider: getSliderStyle(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see KNOWN BUG above
      props.gradientColor1 as string,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see KNOWN BUG above
      props.gradientColor2 as string,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see KNOWN BUG above
      props.color as string,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see KNOWN BUG above
      props.handleShadowColor as string,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see KNOWN BUG above
      props.handleGradientColor1 as string,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see KNOWN BUG above
      props.handleGradientColor2 as string,
    ),
  });

  const classes = useStyles() as Record<"parentWrapper" | "slider", string>;

  /*******************
@Purpose : Slider Component
@Parameter : SliderComponentProps
@Author : Techture
 *******************/

  return (
    <div className={classes.parentWrapper}>
      <MuiSliderComponent {...props} type="MinRange" className={classes.slider} />
    </div>
  );
};
SliderComponent.defaultProps = defaultSliderComponentProps;
export default SliderComponent;
